import { useRealtime } from "../utils/RealtimeProvider";
import { UsersIcon } from "components";
import { RealtimeChart } from "./RealtimeChart";
import { t } from "i18next";
import { useGetReportsQuery } from "../../../services/reportsApi";
import { REALTIME_POLLING_MS } from "../utils/realtimeConfig";

const MetricCard = ({ title, value, description }: { title: string; value: string; description: string }) => (
  <div className="relative my-8 bg-white p-4 shadow">
    <UsersIcon className="absolute right-2 top-2 h-10 w-10" />
    <div className="mb-2 pr-12">
      <span className="">{title}</span>
    </div>
    <div className="mb-2 text-3xl font-bold" style={{ color: "#1C67AD" }}>
      {value}
    </div>
    <div className="flex items-center text-sm text-gray-500">{description}</div>
  </div>
);

export const RealtimeTable = () => {
  const { isConnected, realtimeData, isLoading } = useRealtime();
  const { data: activeStats } = useGetReportsQuery(undefined, {
    skip: !isConnected,
    pollingInterval: isConnected ? REALTIME_POLLING_MS : 0,
  });

  const metrics = [
    {
      title: t("realtimeOverview.clientsTotal"),
      value: String(
        (activeStats?.realtime_active_registered_clients ?? 0) + (activeStats?.realtime_active_guest_clients ?? 0)
      ),
      description: t("realtimeOverview.clientsTotalDescription"),
    },
    {
      title: t("realtimeOverview.usersRegistered"),
      value: String(activeStats?.realtime_active_registered_clients ?? 0),
      description: t("realtimeOverview.usersRegisteredDescription"),
    },
    {
      title: t("realtimeOverview.guestUsersGuests"),
      value: String(activeStats?.realtime_active_guest_clients ?? 0),
      description: t("realtimeOverview.guestUsersGuestsDescription"),
    },
    {
      title: t("realtimeOverview.devicesRegistered"),
      value: String(activeStats?.realtime_active_registered_users_sessions ?? 0),
      description: t("realtimeOverview.devicesRegisteredDescription"),
    },
  ];

  if (isLoading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <div className="text-lg" style={{ color: "#1C67AD" }}>
          {t("common.loading")}
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>
      <div className="bg-white px-8 py-4 shadow">
        <div className="relative h-96">
          {isConnected ? (
            <RealtimeChart />
          ) : (
            <div className="flex h-full items-center justify-center text-center">
              <div>
                <div className="mb-4 text-lg text-red-600">{t("realtimeOverview.disconnected")}</div>
                <div className="text-sm text-gray-500">{t("realtimeOverview.connectToViewData")}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
